import { createContext, ReactNode, useState } from 'react';
import { api } from '../server/api';
import {
  IAllLandingBusiness,
  ILandingBusiness,
  ILandingBusinessPage,
} from '../interfaces/ILandingBusiness';
import * as routes from '../constants/Routes';
import { useNavigate } from 'react-router-dom';

interface LandingBusinessContextProviderProps {
  children: ReactNode;
}

interface LandingBusinessContextProps {
  allLandingBusiness: IAllLandingBusiness[];
  landingBusiness: ILandingBusiness;
  landingBusinessPage: ILandingBusinessPage;
  getAllLandingBusiness: (clientId: string, playerId?: string) => void;
  getLandingBusinessById: (bussinessId: string) => void;
  getLandingBusinessPage: (playerId: string, bussinessId: string) => void;
}

export const landingBusinessContext = createContext(
  {} as LandingBusinessContextProps
);

export function LandingBusinessContextProvider(
  props: LandingBusinessContextProviderProps
) {
  const navigate = useNavigate();
  const [landingBusiness, setLandingBusiness] = useState<ILandingBusiness>();
  const [landingBusinessPage, setLandingBusinessPage] =
    useState<ILandingBusinessPage>();
  const [allLandingBusiness, setAllLandingBusiness] = useState<
    IAllLandingBusiness[]
  >([]);

  async function getLandingBusinessById(bussinessId: string) {
    try {
      const response = await api.get(`/landing-business/find/${bussinessId}`);
      if (response.data.error) {
        throw new Error();
      }
      setLandingBusiness(response.data.body);
    } catch (error) {
      console.log('getlandingBusinessById error: ', error);
    }
  }

  async function getAllLandingBusiness(clientId: string, playerId?: string) {
    try {
      let url = `/landing-business/list/${clientId}?active=true`;
      if (playerId) {
        url += `&playerId=${playerId}`;
      }

      const response = await api.get(url);

      if (response.data.error) {
        throw new Error();
      }

      setAllLandingBusiness(response.data.body);
    } catch (error) {
      console.log('getAllLandingBusiness error: ', error);
    }
  }

  async function getLandingBusinessPage(playerId: string, bussinessId: string) {
    try {
      const response = await api.get(
        `/landing-business/page?playerId=${playerId}&landingId=${bussinessId}`
      );

      if (response.data?.body) {
        setLandingBusinessPage(response.data.body);
      }
    } catch (error) {
      console.log('getLandingBusinessPage error: ', error);
      navigate(routes.NOT_FOUND);
    }
  }

  return (
    <landingBusinessContext.Provider
      value={{
        allLandingBusiness,
        landingBusiness,
        landingBusinessPage,
        getLandingBusinessById,
        getAllLandingBusiness,
        getLandingBusinessPage,
      }}
    >
      {props.children}
    </landingBusinessContext.Provider>
  );
}
